module.exports = __webpack_public_path__ + "static/media/TrainingAvatars.98bd46b9.png";